import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_uom_readService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { owner: string, project: string, material: string }): Promise<{ uoms?: $frontendTypes.FootprintEdi.Uom[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.owner)) {
      $missingRequiredInParams.push('\'owner\'');
    }
    if (isNil($inParams.project)) {
      $missingRequiredInParams.push('\'project\'');
    }
    if (isNil($inParams.material)) {
      $missingRequiredInParams.push('\'material\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

